import React, { useEffect, useRef } from 'react';

import { DealerRegistrationFormWidget } from '../../../widgets/dealerRegistrationForm';

const applyTheme = (theme: string | null) => {
  const resolved = theme === 'dark' ? 'dark' : 'light';
  document.documentElement.setAttribute('data-theme', resolved);
};

export const DealerRegistrationForm = () => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Тему узнаём от встраивающей страницы двумя каналами:
    // URL — чтобы не мигало светлым на первой отрисовке, postMessage — для живого переключения.
    applyTheme(new URL(window.location.href).searchParams.get('theme'));

    const handleThemeMessage = (event: MessageEvent) => {
      if (event.data && event.data.type === 'gm-theme') {
        applyTheme(event.data.theme);
      }
    };

    window.addEventListener('message', handleThemeMessage);

    return () => {
      window.removeEventListener('message', handleThemeMessage);
    };
  }, []);

  useEffect(() => {
    const sendHeight = () => {
      if (window.parent === window) {
        return;
      }

      if (!containerRef.current) {
        return;
      }

      const height = containerRef.current.scrollHeight;

      window.parent.postMessage({ type: 'gm-embed-height', height }, '*');
    };

    const resizeObserver = new ResizeObserver(sendHeight);
    resizeObserver.observe(document.body);

    const mutationObserver = new MutationObserver(sendHeight);
    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      characterData: true,
    });

    const interval = setInterval(sendHeight, 1000);

    return () => {
      resizeObserver.disconnect();
      mutationObserver.disconnect();
      clearInterval(interval);
    };
  }, []);

  return (
    <div ref={containerRef}>
      <DealerRegistrationFormWidget />
    </div>
  );
};
